import type { Lucid } from '../../types/types';
import isDefined from '../guards/isDefined';

const withExternalLogos = (logos: string[], queriedLogos: Lucid.Directus.Generated.External_Logo[]) =>
  logos.map(slug => queriedLogos.find(logo => logo.name === slug)).filter(isDefined);

export default withExternalLogos;
